import axios from "axios";
import { convertUrl } from "../helpers/helper";

const state = {
  companies: [],
  companiesList: [],
  paginationPages: 0,
  paginationCurrentPage: 1,
  validationErrors: [],
  isLoading: false,
};

const mutations = {
  SET_COMPANIES(state, data) {
    state.companies = data;
  },

  SET_COMPANIES_LIST(state, data) {
    state.companiesList = data;
  },

  SET_PAGINATION_PAGES(state, data) {
    state.paginationPages = data;
  },

  SET_PAGINATION_CURRENT_PAGE(state, data) {
    state.paginationCurrentPage = data;
  },

  SET_VALIDATION_ERRORS(state, data) {
    state.validationErrors = data;
  },

  SET_IS_LOADING(state, data) {
    state.isLoading = data;
  },
};

const actions = {
  async getCompanies({ commit }, payload) {
    commit("SET_COMPANIES", []);
    commit("SET_IS_LOADING", true);
    try {
      const apiUrl = convertUrl("company", payload);
      let { data } = await axios.get(apiUrl);
      if (Array.isArray(data)) {
        commit("SET_COMPANIES", data);
      } else {
        commit("SET_COMPANIES", data?.result);
        commit("SET_PAGINATION_PAGES", data?.pages);
      }
    } catch (error) {
      commit("SET_COMPANIES", []);
      return error;
    }
    commit("SET_IS_LOADING", false);
  },

  async getCompaniesList({ commit }, payload) {
    try {
      let apiUrl = convertUrl("company", payload);
      let { data } = await axios.get(apiUrl);
      if (Array.isArray(data)) {
        commit("SET_COMPANIES_LIST", data);
      }
    } catch (error) {
      commit("SET_COMPANIES_LIST", []);
    }
  },

  async saveCompany({ dispatch, commit }, payload) {
    try {
      await axios.post("company", payload);
      dispatch("getCompanies", { page: 1 });
    } catch (error) {
      if (error.response.status == 400) {
        commit("SET_VALIDATION_ERRORS", error?.response?.data?.message);
      } else {
        commit("SET_VALIDATION_ERRORS", ["No se pudo realizar está operación"]);
      }
      throw new Error(error);
    }
  },

  async updateCompany({ dispatch, commit }, payload) {
    try {
      await axios.put(`company/${payload.id}`, payload);
      dispatch("getCompanies", { page: 1 });
    } catch (error) {
      if (error.response.status == 400) {
        commit("SET_VALIDATION_ERRORS", error?.response?.data?.message);
      } else {
        commit("SET_VALIDATION_ERRORS", ["No se pudo realizar está operación"]);
      }
      throw new Error(error);
    }
  },

  async deleteCompany({ dispatch }, id) {
    try {
      await axios.delete(`company/${id}`);
      dispatch("getCompanies", { page: 1 });
    } catch (error) {
      throw new Error("No se pudo realizar está operación");
    }
  },

  cleanValidationErrors({ commit }) {
    commit("SET_VALIDATION_ERRORS", []);
  },

  updateCurrentPage({ commit }, page) {
    commit("SET_PAGINATION_CURRENT_PAGE", page);
  },
};

const getters = {
  getCompanies(state) {
    return state.companies;
  },
  getCompaniesList(state) {
    return state.companiesList;
  },
  getPaginationPages(state) {
    return state.paginationPages;
  },
  getValidationErrors(state) {
    return state.validationErrors;
  },
};

const companies = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default companies;
